import type { EmotionCache, Options } from '@emotion/cache'
import createCache from '@emotion/cache'

interface EmotionCacheOptions extends Omit<Options, 'container'> {
  container: ShadowRoot | HTMLElement | undefined
}

/**
 * Emotion cache creator with default settings.
 */
export const createEmbedEmotionCache = (
  options: Partial<EmotionCacheOptions>,
): EmotionCache =>
  createCache({
    key: 'fwn',
    speedy: true,
    ...options,
  })
